export const SETTINGS_ACCESS_PERMISSIONS = [
  "view_settings",
  "export_quickbooks",
  "view_users",
  "view_audit",
  "view_company",
  "view_department",
  "view_product_category",
];

export const asPermissionList = (data) => {
  if (!data) return [];
  if (Array.isArray(data)) {
    return data
      .map((item) => {
        if (typeof item === "string") return item;
        return item?.value || item?.permission || item?.name || item?.code || "";
      })
      .filter(Boolean);
  }
  if (typeof data === "object") {
    if (Array.isArray(data.permissions)) return asPermissionList(data.permissions);
    if (Array.isArray(data.data)) return asPermissionList(data.data);
    const trueKeys = Object.keys(data).filter((key) => data[key] === true);
    if (trueKeys.length) return trueKeys;
  }
  return [];
};

export const hasAnyPermission = (permissions = [], required = []) =>
  required.some((permission) => permissions.includes(permission));
